export interface LimitCoinsCache {
  limitCoinsStartShowTime?: number;
  limitCoinsPurchaseTime?: number;
}

export interface LimitCoinsSettingParams {
  limited_coinoffer_chance_interval: number; // 启动app，满足出limit coins，需要等待的时间时长
  limited_coinoffer_initial_interval: number; // 购买limit coins后，下次显示的时间间隔
  limited_coinoffer_interval: number; // limit coins倒计时时长
  limited_coinoffer_duration: number; // 倒计时结束后，下次显示的时间间隔
}

export enum LimitSettingParamsMap {
  t1 = "limited_coinoffer_initial_interval",
  t2 = "limited_coinoffer_chance_interval",
  t3 = "limited_coinoffer_duration",
  t4 = "limited_coinoffer_interval"
}
